"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolvers = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// typescript import
// graphql typescript
// definition
var resolvers = {
  Mutation: {
    login: function () {
      var _login = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_, _ref, _ref2) {
        var _ref$input, email, password, gRecaptchaResponse, cname, client, res, defaultResponse, data, type, adminStatus, error, token, code;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref$input = _ref.input, email = _ref$input.email, password = _ref$input.password, gRecaptchaResponse = _ref$input.gRecaptchaResponse, cname = _ref$input.cname;
                client = _ref2.client;
                _context.next = 4;
                return fetch('/api/auth/login', {
                  method: 'post',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  credentials: 'same-origin',
                  body: JSON.stringify(_objectSpread({
                    email: email,
                    password: password,
                    'g-recaptcha-response': gRecaptchaResponse
                  }, !cname ? {} : {
                    type: 'helper',
                    cname: cname
                  }))
                });

              case 4:
                res = _context.sent;
                defaultResponse = {
                  __typename: 'LoginResponse',
                  status: 'FAIL',
                  message: null,
                  role: null,
                  adminStatus: null,
                  token: null
                };

                if (!(res.status !== 200)) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", _objectSpread(_objectSpread({}, defaultResponse), {}, {
                  message: "".concat(res.status, " ").concat(res.statusText)
                }));

              case 8:
                _context.next = 10;
                return res.json();

              case 10:
                data = _context.sent;
                type = data.type, adminStatus = data.adminStatus, error = data.error, token = data.token, code = data.code;

                if (!error) {
                  _context.next = 19;
                  break;
                }

                _context.t0 = code;
                _context.next = _context.t0 === 404 ? 16 : _context.t0 === 403 ? 17 : 18;
                break;

              case 16:
                return _context.abrupt("return", error === 'Invalid recaptcha response' ? _objectSpread(_objectSpread({}, defaultResponse), {}, {
                  status: 'INVALID_RECAPTCHA_RESPONSE'
                }) : _objectSpread(_objectSpread({}, defaultResponse), {}, {
                  message: error
                }));

              case 17:
                return _context.abrupt("return", _objectSpread(_objectSpread({}, defaultResponse), {}, {
                  status: 'NOT_VERIFIED'
                }));

              case 18:
                return _context.abrupt("return", _objectSpread(_objectSpread({}, defaultResponse), {}, {
                  message: error
                }));

              case 19:
                if (!(type === 'merchant_applicant')) {
                  _context.next = 21;
                  break;
                }

                return _context.abrupt("return", _objectSpread(_objectSpread({}, defaultResponse), {}, {
                  token: token,
                  status: 'MERCHANT_APPLICANT'
                }));

              case 21:
                _context.next = 23;
                return client.resetStore();

              case 23:
                return _context.abrupt("return", _objectSpread(_objectSpread({}, defaultResponse), {}, {
                  status: 'OK',
                  role: type.toUpperCase(),
                  adminStatus: adminStatus
                }));

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function login(_x, _x2, _x3) {
        return _login.apply(this, arguments);
      }

      return login;
    }()
  }
};
exports.resolvers = resolvers;